import api from '../../api/api';
import type { ProductCardProps } from '../../types/types';

// API function to fetch all products
export const getAllProducts = async (): Promise<ProductCardProps[]> => {
  try {
    const response = await api.get('/products/all-products/');
    if (!response.data || !Array.isArray(response.data)) {
      console.warn("Kutilgan mahsulotlar ma'lumotlari topilmadi:", response.data);
      return [];
    }
    return response.data.map((product: any) => ({
      id: product.id.toString(),
      title: product.title,
      price: product.price,
      image: Array.isArray(product.images) ? product.images : [],
      discount: product.discount || null,
      discount_price: product.discount_price || null,
      feature: product.feature || false,
      selectedFeature: product.selectedFeature || null,
      sold_count: product.sold_count ?? null,
      view_count: product.view_count ?? null,
      rating: product.rating ?? null,
    }));
  } catch (error) {
    console.error("Barcha mahsulotlarni olishda xatolik:", error);
    return [];
  }
};



export interface RawStoreProduct {
  id: number;
  title: string;
  price: number;
  discount: number | null;
  discount_price: number | null;
  count: number | null;
  feature: boolean;
  images: string[];
  sold_count: number;
  view_count: number;
  rating: number;
}

export interface StoreProductsResponse {
  count: number;
  total_pages: number;
  current_page: number;
  results: RawStoreProduct[];
}

export const getStoreProducts = async (
  address: string,
  page = 1
): Promise<StoreProductsResponse> => {
  const res = await api.get(`/role/seller/store/${address}/products/`, {
    params: { page },
  });
  return res.data;
}


export const getStore = async (address: string) => {
  const res = await api.get(`/role/seller/store/${address}/`);
  return res.data;
}
